export const EXTERNAL_URLS = {
  HELP_DESK: 'https://lichtblick.atlassian.net/servicedesk/customer/portal/36/group/129/create/537',
  WIKI_ACCESS: 'https://lichtblick.atlassian.net/wiki/spaces/INSTALLION/pages/6801489990/Access+to+the+apps',
  MS_TEAMS_CHAT: 'https://teams.microsoft.com/l/chat/0/0?users=',
  OFFICE_DOCS_VIEWER: 'https://view.officeapps.live.com/op/embed.aspx?src=',
} as const;
